const userGridData = [
    {
        id: 1,
        font: 'D',
        name: 'David McHenry',
        text: 'UI/UX Designer',
        projects: ['Photoshop', 'illustrator'],
        email: 'david@skote.com'
    },
    {
        id: 2,
        image: '/images/users/avatar-2.jpg',
        name: 'Frank Kirk',
        text: 'Frontend Developer',
        projects: ['Html', 'Css', '2 + more'],
        email: 'frank@skote.com'
    },
    {
        id: 3,
        image: '/images/users/avatar-3.jpg',
        name: 'Rafael Morales',
        text: 'Backend Developer',
        projects: ['Php', 'Java', 'Python'],
        email: 'Rafael@skote.com'
    },
    {
        id: 4,
        font: 'M',
        name: 'Mark Ellison',
        text: 'Full Stack Developer',
        projects: ['Ruby', 'Php', '2 + more'],
        email: 'mark@skote.com'
    },
    {
        id: 5,
        image: '/images/users/avatar-4.jpg',
        name: 'Minnie Walter',
        text: 'Frontend Developer',
        projects: ['Html', 'Css', '2 + more'],
        email: 'minnie@skote.com'
    },
    {
        id: 6,
        image: '/images/users/avatar-5.jpg',
        name: 'Shirley Smith',
        text: 'UI/UX Designer',
        projects: ['Photoshop', 'illustrator'],
        email: 'shirley@skote.com'
    },
    {
        id: 7,
        font: 'J',
        name: 'John Santiago',
        text: 'Full Stack Developer',
        projects: ['Ruby', 'Php', '2 + more'],
        email: 'john@skote.com'
    },
    {
        id: 8,
        image: '/images/users/avatar-5.jpg',
        name: 'Colin Melton',
        text: 'Backend Developer',
        projects: ['Php', 'Java', 'Python'],
        email: 'colin@skote.com'
    },
];

export { userGridData };